import { Bot, Braces, GitPullRequestArrow, ShieldCheck } from "lucide-react";
import { AnimatedText } from "../components/AnimatedText";
import { ContactButton } from "../components/ContactButton";
import { FadeIn } from "../components/FadeIn";
import { education, profile, resumeDownloadName, resumeHref } from "../content/portfolio";

const orbitItems = [
  { icon: Braces, label: "研发背景", className: "about-orbit about-orbit--one" },
  { icon: GitPullRequestArrow, label: "CI/CD 门禁", className: "about-orbit about-orbit--two" },
  { icon: ShieldCheck, label: "质量证据", className: "about-orbit about-orbit--three" },
  { icon: Bot, label: "AI 工程化", className: "about-orbit about-orbit--four" },
] as const;

export function AboutSection() {
  return (
    <section id="about" aria-labelledby="about-heading" className="about-section">
      <div className="about-grid" aria-hidden="true" />
      {orbitItems.map(({ icon: Icon, label, className }, index) => (
        <FadeIn key={label} delay={index * 0.08} x={index % 2 === 0 ? -36 : 36} y={0} className={className}>
          <Icon aria-hidden="true" />
          <span>{label}</span>
        </FadeIn>
      ))}

      <div className="about-inner">
        <FadeIn as="h2" id="about-heading" y={34} className="section-heading section-heading--dark">
          关于我
        </FadeIn>
        <AnimatedText text={profile.summary} className="about-statement" />
        <FadeIn delay={0.12} className="about-path">
          <span>网络工程本科</span>
          <i aria-hidden="true" />
          <span>Java 开发</span>
          <i aria-hidden="true" />
          <span>测试开发</span>
          <i aria-hidden="true" />
          <span>AI 测试工具</span>
        </FadeIn>
        <FadeIn delay={0.18} className="about-meta">
          <p>
            <strong>{education.school}</strong>
            <span>{education.major} · {education.period}</span>
          </p>
          <p>
            <strong>当前方向</strong>
            <span>{profile.seeking}</span>
          </p>
        </FadeIn>
        <FadeIn delay={0.24} className="about-actions">
          <ContactButton href="#projects">查看代表项目</ContactButton>
          <a className="text-link" href={resumeHref} download={resumeDownloadName}>
            下载简历
          </a>
        </FadeIn>
      </div>
    </section>
  );
}
